import styled from 'styled-components';
import color from '../../configs/color';

export const Wrapper = styled.div`
  .component_modal_remove_member_text {
    color: ${color.black2};
  }
`;

export default Wrapper;
